import { useState, useEffect } from "react";
import { EnforcementSiteDetails } from "./siteDetails";
import StringHelpers from "../../utilities/stringHelpers";
import Loader from "../shared/loader";
import FlipMove from 'react-flip-move';
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import arrayUtilities from "../../utilities/arrayUtilities";

export const AllSitesSummaries = (props) => {
	const location = useLocation()
	const [selectedSiteId, setSelectedSiteId] = useState(location && location.state !== undefined && location.state.siteId !== undefined ? location.state.siteId : null);
	const [selectedClientId, setSelectedClientId] = useState(null);

	const hasSiteSummaries = !arrayUtilities.isNullOrEmpty(props.siteSummaries)

	const sortBySiteName = (a, b) => {
		const nameA = (a.siteName ?? "").toUpperCase()
		const nameB = (b.siteName ?? "").toUpperCase()
		if (nameA < nameB) {
			return -1;
		}
		if (nameA > nameB) {
			return 1;
		}
		return 0;
	}

	const reOrderSitesByCount = () => {
		if (!hasSiteSummaries) return []
		const populatedSites = props.siteSummaries.filter(item => item.count > 0).sort(sortBySiteName)
		const nonPopulatedSites = props.siteSummaries.filter(item => item.count === 0).sort(sortBySiteName)

		return [...populatedSites, ...nonPopulatedSites]
	}

	// keyed on siteSummaries (not just mount) because this component can now mount before any summaries
	// have loaded; a deep-linked site's client is resolved the first time the summaries contain it
	useEffect(() => {
		if (selectedClientId !== null || !hasSiteSummaries) return
		if (location && location.state !== undefined && location.state.siteId !== undefined) {
			const siteSummary = props.siteSummaries.find(item => item.siteId === location.state.siteId)
			if (siteSummary !== undefined) {
				setSelectedClientId(siteSummary.clientId)
			}
		}
	}, [props.siteSummaries])

	const showNavLoader = !hasSiteSummaries && props.isLoadingSummaries
	const showNavEmptyIcon = !hasSiteSummaries && !props.isLoadingSummaries
	const showSiteDetails = hasSiteSummaries && !StringHelpers.isNullOrEmpty(selectedSiteId) && !StringHelpers.isNullOrEmpty(selectedClientId)
	const showBlankPanel = hasSiteSummaries && !showSiteDetails

	return (
		<div className="card-body p-0 mt-3">
			<div className="row">
				<div className="col-2 p-0 pl-3 navbar-vertical scrollbar perfect-scrollbar navbar-light enforcement-sites-navbar">
					<div className="navbar-vertical-content">
						{
							showNavLoader &&
							<div className="d-flex justify-content-center py-3">
								<span className="tiny-loader mb-0"><Loader /></span>
							</div>
						}
						{
							showNavEmptyIcon &&
							<div className="h-100 all-sites-summaries-empty d-flex align-items-center justify-content-center py-3 text-400" title="No sites match these filters">
								<i className="fas fa-store-alt-slash fs-2"></i>
							</div>
						}
						<FlipMove>
						{reOrderSitesByCount().map((item) => (
							<a
								onClick={() => {
									setSelectedSiteId(item.siteId);
									props.onSiteChange && props.onSiteChange(item.siteId)
									setSelectedClientId(item.clientId);
								}}
								key={item.siteId}
								className="nav-link cursor-pointer">
								<div className="d-flex align-items-center text-800 justify-content-between">
									<p
										className={`m-0 font-weight-bolder ${
											selectedSiteId === item.siteId ? "text-primary" : ""
										}`}>
										{item.siteName}
									</p>
									<div className='nav-badge d-flex justify-content-end'>
										{
											props.isLoadingSummaries
												? <span className='tiny-loader mb-0'><Loader /></span>
												: <span
													className={ `badge ml-2 ${ item.count > 0 ? "badge-success" : "badge-secondary"
														}` }>
													{ StringHelpers.formatDecimal(item.count, 0) }
												</span>
										}
									</div>
								</div>
							</a>
						))}
						</FlipMove>
					</div>
				</div>
				<div className="col-10 rounded">
					{
						showNavEmptyIcon &&
						<div className="d-flex bg-white card align-items-center justify-content-center" style={{ height: "500px" }}>
							<div className="all-sites-summaries-empty d-flex flex-column align-items-center">
								<i className="fas fa-filter fs-2 text-300 mb-3"></i>
								<p className="m-0 fs-0 text-600">No sites match these filters</p>
							</div>
						</div>
					}
					{
						showNavLoader &&
						<div className="d-flex bg-white card" style={{ height: "500px" }} />
					}
					{showSiteDetails && (
						<EnforcementSiteDetails
							isRedoing={props.isRedoing}
							statuses={props.statuses}
							previousStatuses={props.previousStatuses}
							type={props.type}
							filterEnd={props.filterEnd}
							filterStart={props.filterStart}
							searchQuery={props.searchQuery}
							isOnHold={props.isOnHold}
							isAssigned={props.isAssigned ?? null}
							contraventionId={props.contraventionId}
							excludeVoided={props.excludeVoided}
							tagIds={props.tagIds}
							selectedSiteId={selectedSiteId}
							selectedClientId={selectedClientId}
							organisationId={props.organisationId}
							token={props.token}
							siteSummaries={props.siteSummaries}
							setCanRedo={props.setCanRedo}
							isSelectAllChecked={props.isSelectAllChecked}
							setIsSelectAllChecked={props.setIsSelectAllChecked}
							multiSelectList={props.multiSelectList}
							setMultiSelectList={props.setMultiSelectList}
							setCanSendToDebtRecovery={props.setCanSendToDebtRecovery}
							showAppealReceivedDateColumn={!arrayUtilities.isNullOrEmpty(props.statuses) && (props.statuses.includes("200") || props.statuses.includes("210"))}
						/>
					)}
					{
						showBlankPanel &&
						<div className="d-flex bg-white card" style={{ height: "500px" }} />
					}
				</div>
			</div>
		</div>
	);
};
